<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="studentDiscounts"
      :items-per-page="5"
      class="elevation-1"
    >
      <template v-slot:item.action="{ item }">
        <v-icon @click="openChangeDiscountDialog(item)">
          mdi-account-check</v-icon
        >
      </template>

      <template v-slot:item.status="{ item }">
        <span
          class="badge bg-success"
          v-if="item && item.status == 'Approved'"
          >{{ item.status }}</span
        >
        <span
          class="badge bg-error"
          v-else-if="item && item.status == 'Not Approved'"
          >{{ item.status }}</span
        >
        <span class="badge bg-warning" v-else>{{ item.status }}</span>
      </template>
    </v-data-table>

    <GlobalDialogSlot
      :title="title"
      :dialog="dialog"
      @close-dialog="closeDialog"
    >
      <v-card v-if="discount">
        <v-row>
          <v-col :cols="isMobile ? 12 : 4">
            <v-card-subtitle>{{ discount.sid }}</v-card-subtitle>
          </v-col>

          <v-col :cols="isMobile ? 12 : 4">
            <v-card-subtitle>{{ discount.amount }}</v-card-subtitle>
          </v-col>

          <v-col :cols="isMobile ? 12 : 4">
            <v-card-subtitle>{{ discount.reason }}</v-card-subtitle>
          </v-col>
        </v-row>
        <v-row>
          <v-col :cols="isMobile ? 12 : 6">
            <vAutoComplete
              class="mx-4"
              :items="statuses"
              @item-selected="changeStatusOfDiscount"
              label="Select Status"
            ></vAutoComplete>
          </v-col>
        </v-row> </v-card
    ></GlobalDialogSlot>
  </div>
</template>
<script>
import studentsJs from "@/plugins/students";
import vAutoComplete from "@/components/Legos/vAutoComplete.vue";
import GlobalDialogSlot from "@/components/myLibrary/GlobalDialogSlot.vue";
export default {
  props: {
    discounts: {
      default: () => [],
    },
  },
  computed: {
    isManager() {
      return this.$store.getters.isManager;
    },
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  watch: {
    discounts(newVal) {
      this.studentDiscounts = newVal;
    },
  },
  mounted() {
    this.studentDiscounts = this.discounts;
  },
  components: { GlobalDialogSlot, vAutoComplete },
  data: () => ({
    dialog: false,
    title: "Determine Discount Status",
    discount: null,
    studentDiscounts: [],
    statuses: ["Pending", "Approved", "Not Approved"],
    headers: [
      { text: "Action", value: "action" },
      { text: "SID", value: "sid" },
      { text: "Amount", value: "amount" },
      { text: "Reason", value: "reason" },
      { text: "Status", value: "status" },
      { text: "Approved By", value: "approved_by" },
      { text: "Created On", value: "created_on" },
    ],
  }),
  methods: {
    openChangeDiscountDialog(discount) {
      if (this.isManager) {
        this.discount = discount;
        this.dialog = true;
      }
    },
    async changeStatusOfDiscount(status) {
      this.$store.commit("setLoader", true);
      this.studentDiscounts = await studentsJs.changeStatusOfDiscount(
        this.discount.id,
        status
      );
      this.$store.commit("setLoader", false);
    },
    closeDialog() {
      this.dialog = false;
      this.discount = null;
    },
  },
};
</script>
